var splitCapsRegexp = /[A-Z]/g;
var getMsgFromCls = function getMsgFromCls(className) {
  return className.replace(splitCapsRegexp, function (match) {
    return " ".concat(match);
  }).trim().split(' ').map(function (word, idx) {
    return idx === 0 ? word : word.toLowerCase();
  }).join(' ');
};

export { getMsgFromCls };
